import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import { Title, Button, Box, Text } from "../../components/Core";

const CTA = () => (
  <>
    {/* <!-- CTA section --> */}
    <Box bg="#79167f" className="position-relative" py={[4, null, null, 5, 6]}>
      <Container>
        <Row className="justify-content-center">
          <Col md="8" lg="7">
            <Box className="text-center">
              <Title color="light">Choose Your Own Campaigns</Title>
              <Text mb={4} color="light" opacity={0.7}>
                Automate this Ramadan by giving daily charity to your chosen campaigns or give to great causes using Message Giving.
              </Text>
              <div className="d-flex flex-column align-items-center pt-3">
              <a href="https://www.muslimgiving.org/autogiving">
                <Button mb={2}>AutoGiving</Button>
              </a>
              </div>
              <div className="d-flex flex-column align-items-center pt-3">
              <a href="https://www.muslimgiving.org/greatcausesfund/easydonate">
                <Button mb={2}>MessageGiving</Button>
              </a>
              </div>
            </Box>
          </Col>
        </Row>
      </Container>
    </Box>
  </>
);

export default CTA;
